import { Steps } from 'antd';

interface StatusStepsProps {
  status?: number;
}

const StatusSteps: React.FC<StatusStepsProps> = ({ status }) => {
  return (
    <div className="mx-auto max-w-4xl p-6">
      <Steps
        className="my-8"
        current={status === undefined ? -1 : status}
        items={[
          {
            title: 'EOB Pending',
            status: status === 0 ? 'finish' : undefined,
          },
          {
            title: 'EOB in Review',
            status: status === 1 ? 'finish' : undefined,
          },
          {
            title: 'EOB Paid',
            status: status === 2 ? 'finish' : undefined,
          },
        ]}
      />
    </div>
  );
};

export default StatusSteps;
